<div
  class="game-container"
  style="overflow: hidden; display: grid; background: black; width: 100vw; height: 100vh; user-select: none"
  (dragstart)="(false)"
>
  <div
    style="display: block"
    [style]="{
      height: inlineOrBlockMargin() === 'inline' ? '100dvh' : undefined,
      width: inlineOrBlockMargin() === 'block' ? '100dvw' : undefined,
      'aspect-ratio': aspectRatio(),
      'margin-block': inlineOrBlockMargin() === 'block' ? 'auto' : undefined,
      'margin-inline': inlineOrBlockMargin() === 'inline' ? 'auto' : undefined,
    }"
  >
    <ng-content></ng-content>
  </div>
</div>
